import { useMemo, useState } from "react";

import { FO, ResourcesContext } from "./ResourcesContext";

export const ResourcesContextProvider = ({ children }) => {
  const [resourceTypeFilter, setResourceTypeFilter] = useState<FO>(null);
  const [productFamilyNameFilter, setProductFamilyNameFilter] =
    useState<FO>(null);
  const [ownerFilter, setOwnerFilter] = useState<FO>(null);
  const [relationshipFilter, setRelationshipFilter] = useState<FO>(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [searchHasError, setSearchHasError] = useState(false);

  const value = useMemo(() => {
    return {
      resourceTypeFilter,
      productFamilyNameFilter,
      ownerFilter,
      relationshipFilter,
      setResourceTypeFilter,
      setProductFamilyNameFilter,
      setOwnerFilter,
      setRelationshipFilter,

      searchQuery,
      setSearchQuery,
      searchHasError,
      setSearchHasError
    };
  }, [
    resourceTypeFilter,
    productFamilyNameFilter,
    ownerFilter,
    relationshipFilter,
    searchQuery,
    searchHasError
  ]);

  return (
    <ResourcesContext.Provider value={value}>
      {children}
    </ResourcesContext.Provider>
  );
};
